module.exports = __webpack_public_path__ + "mbg2.5535b3758c730b8d8beb.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/johnn/Documents/things/innovajsl/src/assets/images/mbg/mbg2.jpg
// module id = ../../../../../src/assets/images/mbg/mbg2.jpg
// module chunks = styles